import React, { memo } from 'react';
import styles from './NotFound.module.scss';
import { default as NotFoundComponent } from 'components/Common/NotFound';

export default memo(() => (
  <div className={styles.not_found_page}>
    <NotFoundComponent errorPageType="ERROR_404" />
  </div>
));
